export enum AnalyticsType {
  ym = 'YM',
  amplitude = 'AMPLITUDE',
  myTracker = 'MY_TRACKER',
  adriver = 'ADRIVER',
  salesNinja = 'SALES_NINJA',
  cpaScaleo = 'CPA_SCALEO',
  roxot = 'ROXOT',
}
